// extracted by mini-css-extract-plugin
export var callCard = "_s5-0";
export var callMessageButton = "_s5-1";
export var helpIcon = "_s5-3";
export var helpIconContainer = "_s5-4";
export var verticalDivider = "_s5-2";